import services from '@/http'
import * as types from './mutation-types'

export const ActionFinishSale = (context, payload) => (
  
  services.cart_checkout.finishSale(payload).then(res => {
    if (res.status == 201) {
      return 201
    }
  })
  .catch(err => {
    console.log('erro:',err)
    alert.log('erro:',err)
    return 400
  })
)

export const ActionDeleteProduct = (context,payload) => (
  services.cart_checkout.deleteProduct({id:payload}).then(res => {
      return res.status    
  })
  .catch(err => {
    err
    return 'ERROR'
  })

)
export const ActionGetPayment = (context) => (
  services.cart_checkout.GetPayment().then(res => {
    context.commit(types.DELIVERY, res.data.results)
  
    return res.status
  })
  .catch(err => {
    err
    return 'ERROR'
  })
)
export const ActionGetDelivery = (context) => (
  services.cart_checkout.GetDelivery().then(res => {
    context.commit(types.PAYMENT, res.data.results)
      return res.status
  })
  .catch(err => {
    err
    return 'ERROR'
  })
)